import { api } from './client';

export interface SisCommissionRow {
  sisGroup: string;
  storeCount: number;
  commissionPct: number;
  settlementDays: number | null;
  notes: string;
  isSet: boolean;
}

export interface SisCommissionInput {
  sisGroup: string;
  commissionPct: number;
  settlementDays?: number;
  notes?: string;
}

export async function listSisCommission(): Promise<SisCommissionRow[]> {
  const r = await api.get<SisCommissionRow[]>('/masters/sis-commission');
  return r.data;
}

export async function saveSisCommission(items: SisCommissionInput[]): Promise<SisCommissionRow[]> {
  const r = await api.put<SisCommissionRow[]>('/masters/sis-commission', { items });
  return r.data;
}
